/**
 * @flow
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux'
import type {DataQueryInfo} from '../types/api-types'
import API from '../services/API'
import {
  updateSharedBranchList,
  updateSharedCompanyList, updateSharedDeviceTypeList,
  updateSharedGroupList,
} from '../redux/reducers/sharedDataReducers'
import {openAlertError} from '../redux/reducers/modalReducer';

// TODO TEST
import {testPatientData} from '../services/TestPatientsListData'

export function useDashboardListView(storeKey: string, actionKey: string, apiKey: string, fields: Array, defaultSortCol: string, defaultOrderBy: string, rowsBuilder?: (rows: Array) => Array) {
  const {queryInfo} = useSelector(s => s[storeKey]);
  const dispatch = useDispatch();
  const queryRows = async (listData, newQI: DataQueryInfo, newFields?: Array) => { // 필드가 동적으로 변경되는 경우 newFields 패러미터를 넘겨주어 동적으로 생성된 필드를 참조할수 있도록함!
    try {
      const {sortCol, orderBy, ...listOption} = newQI ?? queryInfo ?? {};
      const res = await API.dashboardList(listData, {...listOption, sortCol: fields[sortCol ?? defaultSortCol], orderBy: orderBy ?? defaultOrderBy}, dispatch);
      const {data, totalCount} = res;
      const fieldsToUse = newFields ?? fields;
      const rows = data.map(r => {
        const row = {};
        for(const key in fieldsToUse) {
          row[key] = r[fieldsToUse[key]];
        }
        return row;
      });
      dispatch({type: actionKey, rows: rowsBuilder ? rowsBuilder(rows) : rows, totalCount});
    } catch(error) {
      console.log(error);
      openAlertError(dispatch, error);
    }
  };
  return {queryInfo, dispatch, queryRows};
}

export function useSettingsDataView(storeKey: string, actionKey: string, apiKey: string, fields: Array, defaultSortCol: string, defaultOrderBy: string, rowsBuilder?: (rows: Array) => Array) {
  const {queryInfo, openConfirm, openEdit, editMode, editData} = useSelector(s => s[storeKey]);
  const dispatch = useDispatch();
  const queryRows = async (newQI: DataQueryInfo, extraData = null) => {
    // TODO TEST
    if(apiKey === 'dashboardPatientList'){
      const a = testPatientData
         const rows = a.map(r => {
        const row = {};
        for(const key in fields) {
          // jextra가 있는 상황(connect)
          row[key] = r[fields[key]];
        }
        return row;
      });
         dispatch({type: actionKey, rows: rowsBuilder ? rowsBuilder(rows) : rows,});
      }
    
    try {
      const {sortCol, orderBy, ...listOption} = newQI ?? queryInfo ?? {};
      // API[apiKey]요청을 통해서 각 해당하는 사이트의 필요한 row정보들을 가지고 온다.
      const res = await API[apiKey]({action: 'list', data: extraData, listOption: {...listOption, sortCol: fields[sortCol ?? defaultSortCol], orderBy: orderBy ?? defaultOrderBy}});
      const {data, totalCount} = res;
      // 넘어온 정보들을 rows에 key를 재구성하여 저장한다.
      const rows = data.map(r => {
        const row = {};
        for(const key in fields) {
          // jextra가 있는 상황(connect)
          if(key === 'jextra'){
            if(r[key].hasOwnProperty('protocol')){
              for(const j in r[key]){
                 row[j] = r[key][j];
              }
            }
          }
          row[key] = r[fields[key]];
        }
        return row;
      });
      
      console.log('rows', rows)

      dispatch({type: actionKey, rows: rowsBuilder ? rowsBuilder(rows) : rows, totalCount});
    } catch(error) {
      console.log(error);
      openAlertError(dispatch, error);
    }
  };
  const addRow = async (data: Object, extraDataForList = null) => manipulateRow('add', data, extraDataForList);
  const updateRow = async (data: Object, extraDataForList = null) => manipulateRow('edit', data, extraDataForList);
  const deleteRow = async (data: Object, extraDataForList = null) => manipulateRow('delete', data, extraDataForList);
  // 아래의 함수를 통해서 row에 관련한 상태를 변화시켜준다.
  const manipulateRow = async (type: 'add' | 'edit' | 'delete', data: Object, extraDataForList) => {
    console.log('manipulateRow', data);
    try {
      await API[apiKey]({action: type, data});
      await queryRows(queryInfo, extraDataForList); // 현재 쿼리 정보를 사용함
      // 추가 수정 삭제 작업후 열려 있는 다이얼로그를 닫아줌
      dispatch({type: actionKey, openEdit: false, openConfirm: false});
    } catch(error) {
      console.log(error);
      openAlertError(dispatch, error);
    }
  };
  return {
    queryInfo, openConfirm, openEdit, editMode, editData,
    dispatch,
    queryRows, addRow, updateRow, deleteRow,
  };
}

// 회사의 정보를 가지고 와서 사용할 수 있는 함수
export function useSharedData() {
  const {companies, branches, groups, deviceTypes} = useSelector(s => s['sharedData']);
  const dispatch = useDispatch();
  const queryCompanies = async () => querySharedData(dispatch, () => API.companyList(), updateSharedCompanyList);
  const queryBranches = async (parentId) => querySharedData(dispatch, () => API.branchList(parentId), updateSharedBranchList);
  const queryGroups = async (parentId) => querySharedData(dispatch, () => API.groupList(parentId), updateSharedGroupList);
  const queryDeviceTypes = async () => querySharedData(dispatch, () => API.deviceTypeList(), updateSharedDeviceTypeList);
  return {companies, branches, groups, deviceTypes, queryCompanies, queryBranches, queryGroups, queryDeviceTypes};
}

// 회사의 정보를 업데이트 할 수 있게 도와준다.
async function querySharedData(dispatch, api, dispatcher) {
  try {
    const res = await api();
    const data = res.data;
    dispatcher(dispatch, data);
    return data;
  } catch(error) {
    openAlertError(dispatch, error);
  }
}
